import React, { useState, useEffect } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import "./CategorySection.css";
import axios from "axios";

const CategorySection = () => {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await axios.get(
          "https://tarunika.backendapihub.com/product/get/categories"
        );
        const formattedCategories = response.data.data.map((category) => ({
          id: category.categoryID,
          name: category.category_name.toUpperCase(),
          slug: category.category_name.toLowerCase().replace(/\s+/g, '-')
        }));
        setCategories(formattedCategories);
        setLoading(false);
      } catch (err) {
        setError(err.message);
        setLoading(false);
        console.error("Error fetching categories:", err);
      }
    };

    fetchCategories();
  }, []);

  const handleCategoryClick = (categoryID) => {
    navigate(`/products`, { state: { categoryID } });
  };

  if (loading) {
    return (
      <div className="category-navbar">
        <div className="category-container">
          {[...Array(5)].map((_, index) => (
            <div key={index} className="category-link loading">
              <div className="loading-placeholder"></div>
            </div>
          ))}
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="category-navbar">
        <div className="category-container error-message">
          Error loading categories: {error}
        </div>
      </div>
    );
  }

  return (
    <div className="category-navbar">
      <div className="category-container">
        {categories.map((category) => (
          <div
            key={category.id}
            className="category-link"
            onClick={() => handleCategoryClick(category.id)}
          >
            {category.name}
          </div>
        ))}
      </div>
    </div>
  );
};

export default CategorySection;